import React from 'react'
import { build_img, cart_img, green_house_img, home_img, lock_dash_img, properties_img } from '../../assets/imgs'

const PropertyBox = ({ list }) => {
    return (
        <div>
            <p className="f3 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4 primary">
                Properties
            </p>
            <div className='d-flex flex-wrap gap-4 '>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={properties_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_properties}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Properties</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={green_house_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_rooms}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Rooms</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={build_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_individual}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Individual Properties</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={lock_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_room_properties}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Room Properties</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={home_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_properties_in_request}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Properties in Request</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={lock_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_properties_approved}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Properties in Approved</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={cart_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_properties_reject}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Properties in Rejected</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={cart_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_property_suspended}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Total Properties in Suspended</h4>
                </div>

                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={home_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_properties_details_request}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Request for Property Details</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={lock_dash_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_properties_document_request}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Request for property Documents</h4>
                </div>
                <div className='dash-box'>
                    <div className="d-flex ac-jc">
                        <img src={properties_img} alt="" />
                        <p className='f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-0 ms-2'>{list?.total_mmc_request_properties}</p>
                    </div>
                    <h4 className='f2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mb-0 text-center mt-3'>Pending MMC for Live</h4>
                </div>
            </div>
        </div>
    )
}

export default PropertyBox